import React, {useMemo} from "react";

import "./style.less";

import PagesSwitch from "../../../../components/PagesSwitch";
import {usePlatform} from "../../../../context/PlatformContext";
import {useTranslation} from "react-i18next";

import ConfigNav from "./containers/ConfigNav";
import HowDidYouHearAboutUs from "./containers/Platform/components/HowDidYouHearAboutUs";
import CustomizablePopups from "./containers/Platform/components/CustomizablePopups";
import HowYouMetUsIcon from "../../../../components/svg/Account/HowYouMetUs";
import PopupsIcon from "../../../../components/svg/Account/Popups";

const withSidebar = (Section) => (props) => (
    <div className={"Config__layout"}>
        <ConfigNav pages={props.pages}/>
        <div className={"Config__content"}>
            <Section {...props}/>
        </div>
    </div>
);

const SECTION_DEFINITIONS = [
    {
        label: "config.platform.how_did_you_hear_about_us.nav_label",
        path: "how_you_met_us",
        component: withSidebar(HowDidYouHearAboutUs),
        functionality: "how_did_you_hear_about_us",
        icon: HowYouMetUsIcon
    },
    {
        label: "config.platform.customizable_popups.nav_label",
        path: "popups",
        component: withSidebar(CustomizablePopups),
        functionality: "customizable_popups",
        icon: PopupsIcon
    }
];

const ConfigEmpty = () => {
    const {t} = useTranslation();
    return (
        <div className={"Config__empty"}>
            <h3>{t("config.empty.label")}</h3>
            <p>{t("config.empty.info")}</p>
        </div>
    );
};

const Config = ({path}) => {

    const {platform} = usePlatform();
    const functionalities = platform?.functionalities || [];

    const visiblePages = useMemo(() => (
        SECTION_DEFINITIONS.filter(s => !s.functionality || functionalities.includes(s.functionality))
    ), [functionalities]);

    const pages = visiblePages.length > 0 ? visiblePages : [{
        label: "config.empty.label",
        path: "empty",
        component: ConfigEmpty
    }];

    return (
        <div className="Config">
            <PagesSwitch path={path}
                         pages={pages}
                         containerClass={true}
                         boxShadow={true}
                         navBarButton={true}
                         type={"secondary"}
            />
        </div>
    );
};

Config.sections = SECTION_DEFINITIONS;

export default Config;
